import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    resultsPageResponse: null,
    resultsResponse: null,
    playerResultsResponse: null
  },
  getters: {
    RESULTS_PAGE: state => state.resultsPageResponse,
    RESULTS: state => state.resultsResponse,
    PLAYER_RESULTS: state => state.playerResultsResponse
  },
  mutations: {
    SET_RESULTS_PAGE: (state, payload) => {
      state.resultsPageResponse = payload
    },
    SET_RESULTS: (state, payload) => {
      state.resultsResponse = payload
    },
    SET_PLAYER_RESULTS: (state, payload) => {
      state.playerResultsResponse = payload
    }
  },
  actions: {
    FETCH_RESULTS_PAGE: async context => {
      try {
        const response = await Axios.get('/football/results/page-count')
        context.commit('SET_RESULTS_PAGE', response.data)
      } catch (error) {
        context.commit('SET_RESULTS_PAGE', error.response.data)
      }
    },
    FETCH_RESULTS: async (context, payload) => {
      try {
        const response = await Axios.get(`/football/results/${payload}`)
        context.commit('SET_RESULTS', response.data)
      } catch (error) {
        context.commit('SET_RESULTS', error.response.data)
      }
    },
    FETCH_PLAYER_RESULTS: async (context, payload) => {
      try {
        const response = await Axios.get(
          `/football/results/${payload.roundId}/${payload.userId}`
        )
        context.commit('SET_PLAYER_RESULTS', response.data)
      } catch (error) {
        context.commit('SET_PLAYER_RESULTS', error.response.data)
      }
    }
  }
}
